/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ActivityComment
 */
export interface ActivityComment {
  /**
   *
   * @type {string}
   * @memberof ActivityComment
   */
  activityCommentId?: string;
  /**
   *
   * @type {string}
   * @memberof ActivityComment
   */
  activityId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ActivityComment
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ActivityComment
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof ActivityComment
   */
  text?: string;
  /**
   *
   * @type {boolean}
   * @memberof ActivityComment
   */
  isPinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof ActivityComment
   */
  replyTo?: string;
}

/**
 * Check if a given object implements the ActivityComment interface.
 */
export function instanceOfActivityComment(
  value: object,
): value is ActivityComment {
  return true;
}

export function ActivityCommentFromJSON(json: any): ActivityComment {
  return ActivityCommentFromJSONTyped(json, false);
}

export function ActivityCommentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityComment {
  if (json == null) {
    return json;
  }
  return {
    activityCommentId:
      json["activityCommentId"] == null ? undefined : json["activityCommentId"],
    activityId: json["activityId"] == null ? undefined : json["activityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    text: json["text"] == null ? undefined : json["text"],
    isPinned: json["isPinned"] == null ? undefined : json["isPinned"],
    replyTo: json["replyTo"] == null ? undefined : json["replyTo"],
  };
}

export function ActivityCommentToJSON(json: any): ActivityComment {
  return ActivityCommentToJSONTyped(json, false);
}

export function ActivityCommentToJSONTyped(
  value?: ActivityComment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activityCommentId: value["activityCommentId"],
    activityId: value["activityId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    text: value["text"],
    isPinned: value["isPinned"],
    replyTo: value["replyTo"],
  };
}
